import { InjectionToken } from '@angular/core';

import { SidebarComponent } from './sidebar.component';

export const SB_SIDEBAR = new InjectionToken<SidebarComponent>('sb-sidebar');
